export default __webpack_public_path__ + "static/media/dgwbacksplash.aaf1d169.jpg";